import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface TempLayoutsState {
    /** UUID of org that should be currently displayed or what will show if redirecting to the root */
    tempLayouts: string
}

export const uesTempLayoutsStore = create<TempLayoutsState>()(
    devtools(
        (set) => ({
            tempLayouts: '',
        }),
        { name: 'TempLayoutsStore' },
    ),
)

export const useTempLayouts = () => uesTempLayoutsStore((state) => state.tempLayouts)
export const getTempLayouts = () => uesTempLayoutsStore.getState().tempLayouts
export const setTempLayouts = (tempLayouts: string) => uesTempLayoutsStore.setState({ tempLayouts })
